import * as yup from 'yup';
import URL_REGEXP from '../../regex/url';

const URL_VALIDATION = yup.string().matches(URL_REGEXP, {
  excludeEmptyString: true,
  message: 'Invalid URL, ex: https://www.google.com',
});

export default URL_VALIDATION;
